import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { TagsComponent } from './tags.component';

export const MODULE_IMPORTS = [
  CommonModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatIconModule,
  MatInputModule,
  ReactiveFormsModule,
  TranslateModule,

  GalaxyBadgeModule,
  GalaxyFormFieldModule,
  GalaxyTooltipModule,
];

export const MODULE_DECLARATIONS = [TagsComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  exports: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
})
export class GalaxyTagsModule {}
